const mediaQuery = window.matchMedia('(min-width: 992px)');

// TODO: improve handling of multiple tab elements
function tabsPanel() {
    var tabTriggerBtns = document.querySelectorAll('.data-tabs li a');

    tabTriggerBtns.forEach(function (tabTriggerBtn, index) {
        tabTriggerBtn.addEventListener('click', function () {
            var currentTabData = document.querySelector('.data-tab-content[data-tab-content="' + this.dataset.tabTrigger + '"]');

            // remove classess
            if (document.querySelector('.data-tab-content.is-open'))
                document.querySelector('.data-tab-content.is-open').classList.remove('is-open');

            if (document.querySelector('.data-tabs li a.is-active'))
                document.querySelector('.data-tabs li a.is-active').classList.remove('is-active');
            // add classes
            currentTabData.classList.add('is-open');
            this.classList.add('is-active');
        });
    });
}

function accordionPabel() {
    var accItem = document.getElementsByClassName('accordionItem');
    var accHD = document.getElementsByClassName('accordionItemHeading');

    for (let i = 0; i < accHD.length; i++) {
        accHD[i].addEventListener('click', toggleItem, false);
    }
    function toggleItem() {
        var itemClass = this.parentNode.className;
        for (let i = 0; i < accItem.length; i++) {
            accItem[i].className = 'accordionItem close';
        }
        if (itemClass == 'accordionItem close') {
            this.parentNode.className = 'accordionItem open';
        }
    }
}

function init() {
    tabsPanel();
    accordionPabel();
}

export default {
    init,
};
